import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=70541f4f&scoped=true"
import script from "./ListImageGroups.vue?vue&type=script&lang=js"
export * from "./ListImageGroups.vue?vue&type=script&lang=js"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=70541f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70541f4f",
  null
  
)

export default component.exports